<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">checklist</mat-icon>
        <span>{{ tela.descricao }}</span>
        <div class="section-title-actions ms-auto">
            <span class="novo-campo-wrapper" [class.novo-campo-indisponivel]="getCamposDisponiveis().length === 0"
                [matTooltip]="tooltipSemCamposDisponiveis"
                [matTooltipDisabled]="getCamposDisponiveis().length > 0" matTooltipPosition="above">
                <button mat-button type="button" class="btn-section btn-novo-campo" (click)="toggleSeletor()"
                    [disabled]="getCamposDisponiveis().length === 0">
                    <mat-icon class="material-symbols-outlined">{{ seletorAberto ? 'close' : 'add' }}</mat-icon>
                    {{ seletorAberto ? 'Fechar' : 'Novo campo' }}
                </button>
            </span>
        </div>
    </div>
    <p class="section-sub-title">Defina campos obrigatórios para {{ tela.descricao | lowercase }}.</p>

    @if (seletorAberto) {
    <div class="seletor-campos">
        <p class="seletor-titulo">Selecione um campo para torná-lo obrigatório:</p>
        <div class="seletor-lista">
            @for (campo of getCamposDisponiveis(); track campo.idCampo) {
            <button mat-stroked-button type="button" class="btn-secondary"
                [matTooltip]="campo.observacao ?? ''" [matTooltipDisabled]="!campo.observacao"
                (click)="adicionarCampo(campo)">
                @if (campo.observacao) {
                <mat-icon class="material-symbols-outlined icon-nota-pilula">info</mat-icon>
                }
                {{ campo.nomeExibicao }}
            </button>
            }
        </div>
    </div>
    }

    <div class="campos-grid">
        @for (campo of getCamposObrigatorios(); track campo.idCampo) {
        <div class="campo-card">
            <div class="campo-card-content">
                <span class="campo-nome">{{ campo.nomeExibicao }}</span>
                <span class="campo-label">Obrigatório</span>
                @if (campo.observacao) {
                <span class="campo-nota">
                    <mat-icon class="material-symbols-outlined">info</mat-icon>
                    <span>{{ campo.observacao }}</span>
                </span>
                }
            </div>
            <button mat-icon-button type="button" class="campo-action-btn" [disabled]="campo.isFixo"
                (click)="removerCampo(campo)">
                @if (campo.isFixo) {
                <mat-icon class="material-symbols-outlined icon-lock">lock</mat-icon>
                } @else {
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                }
            </button>
        </div>
        }
    </div>
</div>
